import { Directive, HostListener } from '@angular/core';

@Directive({
  selector:
    'input[type="text"], input:not([type]), input[kendoTextBox], kendo-textbox, kendo-textarea',
  standalone: false,
})
export class TrimInputDirective {
  @HostListener('focusout', ['$event'])
  onFocusOut(event: FocusEvent): void {
    const target: EventTarget | null = event?.target;
    if (
      !(target instanceof HTMLInputElement) &&
      !(target instanceof HTMLTextAreaElement)
    ) {
      return;
    }

    const originalValue: string = target.value;
    const trimmedValue: string = originalValue.trim();

    if (originalValue === trimmedValue) {
      return;
    }

    target.value = trimmedValue;
    target.dispatchEvent(new Event('input', { bubbles: true }));
    target.dispatchEvent(new Event('change', { bubbles: true }));
  }
}
